/* eslint-disable prefer-destructuring */
import useTranslation from 'next-translate/useTranslation'
import React, { useEffect, useState } from 'react'
import useMap from 'tennders-transactions/hooks/useMap'
import useOffer from 'tennders-market/offer/hooks/useOffer'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import GOfferRoute from 'tennders-common/form/components/GOfferRoute'
import GHref from 'tennders-market/common/components/element/GHref'
import IconAddFilled from '../../../../icons/icon-add-filled.svg'

const SelectRoute = () => {
  const { mapForm, setMapForm, editMode } = useMap()
  const { transaction } = useTransaction()
  const [pickupStops, setpickupStops] = useState(mapForm?.pickupStops || [])
  const [deliveryStops, setdeliveryStops] = useState(mapForm?.deliveryStops || [])
  const { errors } = useOffer()
  const { t } = useTranslation()

  const getMinPickupDate = (index) => {
    let minPickupDate = mapForm?.pickupRoute
        && mapForm?.pickupRoute.date
        && mapForm?.pickupRoute.date[0]
    if (index === 0) {
      return minPickupDate
    }

    for (let i = 0; i < pickupStops.length && i < index; i += 1) {
      if (pickupStops[i] && pickupStops[i].date) {
        minPickupDate = pickupStops[i].date[0]
      }
    }

    return minPickupDate
  }

  const getMinDeliveryRouteDate = () => {
    let minDate = mapForm?.pickupRoute
        && mapForm?.pickupRoute.date
        && (mapForm?.pickupRoute.date[1] || mapForm?.pickupRoute.date[0])

    for (let i = 0; i < pickupStops.length; i += 1) {
      if (pickupStops[i] && pickupStops[i].date) {
        if (minDate < pickupStops[i].date[0]) {
          minDate = pickupStops[i].date[0]
        } else if (minDate < pickupStops[i].date[1]) {
          minDate = pickupStops[i].date[1]
        }
      }
    }

    return minDate
  }

  const getMinDeliveryDate = (index) => {
    let minDate = mapForm?.deliveryRoute
        && mapForm?.deliveryRoute.date
        && mapForm?.deliveryRoute.date[0]
    if (index === 0) {
      return minDate
    }

    for (let i = 0; i < deliveryStops.length && i < index; i += 1) {
      if (deliveryStops[i]?.date) {
        minDate = deliveryStops[i].date[0]
      }
    }

    return minDate
  }

  const addPickupStop = () => {
    const stop = { identifier: new Date().getTime() }

    setpickupStops([...mapForm?.pickupStops, stop])
  }

  const addDeliveryStop = () => {
    const stop = { identifier: new Date().getTime() }

    setdeliveryStops([...mapForm?.deliveryStops, stop])
  }

  const removePickupStop = (identifier) => {
    setpickupStops(
      [...mapForm?.pickupStops].filter((stop) => stop.identifier !== identifier)
    )
  }

  const removeDeliveryStop = (identifier) => {
    setdeliveryStops(
      [...mapForm?.deliveryStops].filter((stop) => stop.identifier !== identifier)
    )
  }

  useEffect(() => {
    setMapForm({
      // ...form,
      ...mapForm,
      pickupStops,
      deliveryStops
    })
  }, [pickupStops, deliveryStops])

  useEffect(() => {
    setMapForm({
      ...mapForm,
      ...(transaction?.deliveryRoute && {
        deliveryRoute: {
          ...transaction?.deliveryRoute,
          location: {
            ...transaction?.deliveryRoute?.location,
            label: transaction?.deliveryRoute?.label
          },
          date: transaction?.deliveryRoute?.date?.timestamp?.map((t) => new Date(t * 1000))
        }
      }),
      ...(transaction?.deliveryRoutes && {
        deliveryStops: transaction?.deliveryRoutes?.reduce((array, dr) => {
          if (dr.id !== transaction?.deliveryRoute?.id) {
            array.push({
              ...dr,
              location: { ...dr?.location, label: dr?.label },
              date: dr?.date?.timestamp?.map((t) => new Date(t * 1000))
            })
          }
          return array
        }, [])
      }),
      ...(transaction?.pickupRoute && {
        pickupRoute: {
          ...transaction?.pickupRoute,
          location: {
            ...transaction?.pickupRoute?.location,
            label: transaction?.pickupRoute?.label
          },
          date: transaction?.pickupRoute?.date?.timestamp?.map((t) => new Date(t * 1000))
        }
      })
    })
  }, [transaction])

  if (mapForm?.fixedRoute || !editMode) {
    return null
  }

  return (
    <>
      <div className="tennders-add-pickup-delivery">
        <div className="d-flex">
          <div className="w-50">
            <div className="pr-16">
              <GOfferRoute
                disabled={!editMode}
                locationLabel={t('transaction:pickUp')}
                errors={errors && errors.pickupRoute}
                onChange={(location) => setMapForm({ ...mapForm, pickupRoute: location })}
                route={mapForm?.pickupRoute}
                isPickUp
                required
                t={t}
              />
              <div className="hr" />
              {
                mapForm?.pickupStops?.map((location, index) => (
                  <GOfferRoute
                    disabled={!editMode}
                    forDocument
                    errors={errors[`pickupStops[${index}]`]}
                    removeStop={removePickupStop}
                    index={1}
                    locationLabel={`${index + 2}. ${t('transaction:pickupLocation')}`}
                    minDate={
                      getMinPickupDate(index)
                    }
                    maxDate={
                      mapForm?.deliveryRoute?.date && mapForm?.deliveryRoute?.date[0]
                    }
                    key={location.identifier}
                    isPickUp
                    onChange={(location) => {
                      const stops = [...mapForm?.pickupStops]
                      stops[index] = { ...location }
                      setpickupStops(stops)
                    }}
                    route={mapForm?.pickupStops[index]}
                    t={t}
                  />
                ))
              }

              {editMode && (
                <GHref onClick={addPickupStop} className="d-flex align-center mt-32 btn-link">
                  <IconAddFilled className="btn-only-icon" />
                  {t('addEdit:addAnotherPickupStop')}
                </GHref>
              )}
            </div>
          </div>
          <div className="w-50">
            <GOfferRoute
              disabled={!editMode}
              locationLabel={t('transaction:delivery')}
              errors={errors && errors.deliveryRoute}
              onChange={(location) => setMapForm({ ...mapForm, deliveryRoute: location })}
              route={mapForm?.deliveryRoute}
              minDate={getMinDeliveryRouteDate()}
              required
              t={t}
            />
            <div className="hr" />
            {mapForm?.deliveryStops?.map((location, index) => (
              <GOfferRoute
                forDocument
                onlyInput
                disabled={!editMode}
                errors={errors[`deliveryStops[${index}]`]}
                removeStop={removeDeliveryStop}
                index={1}
                locationLabel={`${index + 2}. ${t('transaction:deliveryLocation')}`}
                minDate={
                  getMinDeliveryDate(index)
                }
                key={location.identifier}
                onChange={(location) => {
                  const stops = [...mapForm?.deliveryStops]
                  stops[index] = { ...location }
                  setdeliveryStops(stops)
                }}
                route={mapForm?.deliveryStops[index]}
                t={t}
              />
            ))}
            {editMode && (
              <GHref onClick={addDeliveryStop} className="mt-32 d-flex align-center btn-link">
                <IconAddFilled className="btn-only-icon" />
                {t('addEdit:addAnotherDeliveryStop')}
              </GHref>
            )}
          </div>
        </div>
      </div>
      {editMode && <div className="hr" />}
    </>
  )
}

export default SelectRoute
